import {useQuery} from "@tanstack/react-query"
import axios from "config/axios"
import {ReactQueryKeys} from "config/constant"
import {useParams} from "react-router-dom"
import {useApiDefaults} from "./useApiDefaults"
import { useSelector } from 'react-redux'

export const useGetListDetails = () => {
  const {id} = useParams()
  const apiDefaults = useApiDefaults()
  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const body = {
    list_id: id,
    ...apiDefaults,
  }

  const fetcher = async () => {
    if (!id || !isUserLoggedIn) {
      return {
        customerListName: "",
        customerListDetails: [],
        ListLoading: false,
      }
    }

    const res = await axios.post("/AogGetListWiseProductsList", body)
    return res?.data || {}
  }

  const queryResult = useQuery({
    queryKey: [ReactQueryKeys.LIST_DETAILS, id, apiDefaults],
    queryFn: fetcher,
  })

  return {
    ...queryResult,
    customerListName: queryResult.data?.list_name || "",
    customerListDetails: queryResult.data?.data || [],
    ListLoading: queryResult.isLoading,
    refetchListDetails: queryResult.refetch,
  }
}
